module.exports = __webpack_public_path__ + "img/operate_list3.e888a91a.png";